import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForCheckInBefore_07days = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtCheckInBefore07Days($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtCheckInBefore07Days(input: $input) {
			userErrors
			success
		}
	}
`);
